import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import useLocalStorageState from 'use-local-storage-state';
import { GetRequest } from '../../Utils/hooks/ApiHandler';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { formatDate } from '../../Utils/helpers/commonhelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGem } from '@fortawesome/free-solid-svg-icons';
import { ContactCardSkeleton } from '../../Utils/skeletonLoader/ContactCard';
import { BsArrowLeft } from 'react-icons/bs';


const PaymentDetails = () => {

    const [subscriptionData, setSubscriptionData] = useState(null);
    const navigate = useNavigate();
    const [customer, setCustomer] = useLocalStorageState("customer");
    const [loading, setLoading] = useState(true);

    const customer_id = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const { state } = useLocation();
    const { customer_subscription_id } = state || {};


    const headers = {
        Authentication: rf,
        Authorization: token,
    };

    const fetchSingleSubscription = async () => {
        setLoading(true)
        try {
            const res = await GetRequest(
                `plan/fetchSubscriptionPayments/${customer_subscription_id}`,
                { headers },
                { customer, setCustomer, rf, navigate })
            console.log("API RESPONSE single user :", res);
            if (res) {
                setSubscriptionData(res.data);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (customer_id && customer_subscription_id) {
            fetchSingleSubscription(customer_subscription_id);
        }
    }, [customer_id, customer_subscription_id]);


    const planId =
        subscriptionData?.successful_payments?.[0]?.payment_id || "-";

    const addOneMonth = (date) => {
        const d = new Date(date);
        d.setMonth(d.getMonth() + 1);
        return d;
    };

    const baseExpiry =
        subscriptionData?.successful_payments?.[0]?.expiry_date ||
        subscriptionData?.pending_payments?.[0]?.upcoming_payment_date;


    const allPayments = [
        ...(subscriptionData?.successful_payments || []).map((item) => ({
            type: "success",
            date: item.created_at,
            status: item.status || "success",
            payment_id: planId,
            plan_name: item.plan_name,
            amount: item.amount,
            exp_date: baseExpiry
        })),
        ...(subscriptionData?.pending_payments || []).map((item, index) => {
            const startDate =
                index === 0
                    ? baseExpiry
                    : addOneMonth(baseExpiry).setMonth(
                        addOneMonth(baseExpiry).getMonth() + (index - 1)
                    );

            const expiryDate = addOneMonth(startDate);
            return {
                type: "pending",
                payment_id: planId,
                plan_name: item.plan_name,
                amount: item.amount,
                start_date: startDate,
                expiry_date: expiryDate
            }
        })
    ]

    console.log(allPayments);

    return <>
        <div style={{ minHeight: "100vh", padding: "20px 0", marginBottom: "10px" }}>
            <Container fluid>
                <Row className=" gx-4 mb-3">
                    <Col className="d-flex justify-content-between">
                        <p className='text-muted fs-6'>Stay informed about renewals and manage your billing timeline with ease.</p>
                        <Button className='btn btn-default-outline' onClick={() => navigate(-1)}>
                            <BsArrowLeft className="me-1" /> Back
                        </Button>
                    </Col>
                </Row>
                {loading ? (
                    <Row>
                        {
                            [...Array(5)].map((i) => (
                                <ContactCardSkeleton key={i} />
                            ))
                        }
                    </Row>
                ) : (
                    <Row className='row-cols-1 row-cols-md-3 gx-3' >
                        {allPayments.map((payment, index) => (
                            <Col key={index}>
                                <Card
                                    className={`rounded-3`}
                                    style={{
                                        borderWidth: "1.5px",
                                        borderStyle: "dotted",
                                        borderColor: "#198754",
                                        boxShadow: "0px 0px 15px  #d0d0d0",
                                        backgroundColor: payment.type === "success" ? "#fffbdd" : "#fff"
                                    }}
                                >
                                    <Card.Body style={{'padding' : '0px 0px 0px 0px'}}>
                                        {/* Top Row */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center gap-2">
                                                {/* Icon */}
                                                <div
                                                    className=" d-flex align-items-center justify-content-center"
                                                    style={{ backgroundColor: "#d4dcdd", height: "35px", width: "35px", borderRadius: "5px" }}
                                                >
                                                    <FontAwesomeIcon icon={faGem} style={{ color: "#3687e3" }} />
                                                </div>

                                                {/* Title */}
                                                <div>
                                                    <h6 className="fw-bold mb-0" style={{color:"#7a3a5e"}}>
                                                        {payment.plan_name} Plan
                                                    </h6>
                                                </div>
                                            </div>

                                            {/* Status Pill */}

                                            <h6 className="fw-bold mb-0">
                                                ₹{Number(payment.amount / 100).toLocaleString()}<span className="text-muted small">/month</span>
                                            </h6>
                                        </div>

                                        {/* Dashed Divider */}

                                        <div className='mt-2 d-flex justify-content-between align-items-center'>
                                            <div className="d-flex justify-content-start align-items-center gap-2  ">
                                                <span className='text-muted' style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>
                                                    Plan ID:
                                                </span>
                                                <span className="small" style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>
                                                    {payment.payment_id}
                                                </span>
                                            </div>
                                            <div className='text-end mb-1'>
                                                <span
                                                    className="badge rounded-pill px-3 py-1" style={{
                                                        fontWeight: 500,
                                                        fontSize: "10px",
                                                        backgroundColor: payment.type === "success" ? "#00802b" : "#e6a000"
                                                    }}
                                                >
                                                    {payment.type === "success" ? "Paid" : "Upcoming"}
                                                </span>
                                            </div>

                                        </div>

                                        <hr style={{ marginTop: "0.75rem", marginBottom: "0.75rem", opacity: 0.5, padding: 0 }} />



                                        <div className="d-flex justify-content-between align-items-end">
                                            {payment.type === "success" ? (
                                                <>
                                                    {/* Payment Date */}
                                                    <div >
                                                        <div>
                                                            <span className="text-muted" style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>Payment Date: </span><span style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>{formatDate(payment.date)}</span>
                                                        </div>
                                                    </div>

                                                    {/* Expiry Date */}
                                                    <div >
                                                        <div>
                                                            <span className="text-muted small" style={{ fontSize: "12px" }}>Expiry Date: </span><span style={{ fontWeight: 500, color: "red", fontSize: "12px" }}>
                                                                {payment.exp_date ? formatDate(payment.exp_date)
                                                                    : "-"}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </>
                                            ) : (
                                                /* Due Date only */
                                                <>
                                                    <div>
                                                        <div>
                                                            <span className="text-muted small" style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>Start Date: </span><span style={{ fontWeight: 500, color: "#000", fontSize: "12px" }}>
                                                                {formatDate(payment.start_date)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div>
                                                            <span className="text-muted small" style={{ fontSize: "12px" }}>Expiry Date: </span><span style={{ fontWeight: 500, color: "red", fontSize: "12px" }}>
                                                                {payment.expiry_date ? formatDate(payment.expiry_date)
                                                                    : "-"}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </>
                                            )}
                                        </div>

                                    </Card.Body>
                                </Card>

                            </Col>
                        ))}
                    </Row>
                )
                }

            </Container>
        </div>
    </>

}

export default PaymentDetails